<template>
  <div>
    <SettingGroup>
      <SettingItem label="Wi-Fi スキャンチャネル"></SettingItem>

      <div class="checkboxGroup">
        <div
          class="checkboxRow"
          v-for="([key, value], index) in checkBoxEntries"
          :key="index"
          :style="{ borderBottom: `1px solid ${gray3}` }"
        >
          <label class="rowLabel">{{ value.label }}</label>
            <CheckboxGroup
              :selectedItems="form.checkBox[key]"
              :items="value.items"
              direction="row"
              @update:selectedItems="val => { form.checkBox[key] = val; handleCheckBoxChange(val, key) }"
            />
        </div>
      </div>
    </SettingGroup>

    <SettingGroup>
      <SettingItem label="Wi-Fi 送信出力">
        <RangeSlider
          :inputValue="form.range.txPowerValue"
          @update:inputValue="form.range.txPowerValue = $event"
          :disable="false"
          :minLimit="BC.NETWORK.WIFI.WIFI_TX_POWER_SETTING.TX_POWER_VALUE.MIN"
          :maxLimit="BC.NETWORK.WIFI.WIFI_TX_POWER_SETTING.TX_POWER_VALUE.MAX"
          unit="[dBm]"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup>
      <SettingItem label="Wi-Fi ローミングレベル">
        <RangeSlider
          :inputValue="form.range.roamingLevel"
          @update:inputValue="form.range.roamingLevel = $event"
          :disable="false"
          :minLimit="BC.NETWORK.WIFI.WIFI_ROAMING_SETTING.ROAMING_LEVEL.MIN"
          :maxLimit="BC.NETWORK.WIFI.WIFI_ROAMING_SETTING.ROAMING_LEVEL.MAX"
          unit="[dBm]"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import CheckboxGroup from '@/components/pc/radio/ipradio/atoms/CheckboxGroup.vue'
import RangeSlider from '@/components/pc/radio/ipradio/atoms/RangeSlider.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { CSS_COLORS } from '@/components/pc/radio/ipradio/config/css-constants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'WifiScanBandsAndPowerVue2',
  components: { CheckboxGroup, RangeSlider, SettingGroup, SettingItem },
  data () {
    const checkBoxOptions = {
      scanAll: {
        label: '',
        items: BC.NETWORK.WIFI.SCAN_BANDS.SCAN_ALL.ITEMS.map((_n, i) => ({
          label: BC_TRANS_JP.NETWORK.WIFI.SCAN_BANDS.SCAN_ALL.ITEMS[i],
          value: i,
        })),
      },
      band2G: {
        label: BC.NETWORK.WIFI.SCAN_BANDS.BAND_2G.LABEL,
        items: BC.NETWORK.WIFI.SCAN_BANDS.BAND_2G.ITEMS.map((n, i) => ({ label: n, value: i })),
      },
      w52: {
        label: BC.NETWORK.WIFI.SCAN_BANDS.W52.LABEL,
        items: BC.NETWORK.WIFI.SCAN_BANDS.W52.ITEMS.map((n, i) => ({ label: n, value: i })),
      },
      w53: {
        label: BC.NETWORK.WIFI.SCAN_BANDS.W53.LABEL,
        items: BC.NETWORK.WIFI.SCAN_BANDS.W53.ITEMS.map((n, i) => ({ label: n, value: i })),
      },
      w56: {
        label: BC.NETWORK.WIFI.SCAN_BANDS.W56.LABEL,
        items: BC.NETWORK.WIFI.SCAN_BANDS.W56.ITEMS.map((n, i) => ({ label: n, value: i })),
      },
    }

    return {
      checkBoxOptions,
      form: {
        checkBox: {
          scanAll: [],
          band2G: [],
          w52: [],
          w53: [],
          w56: [],
        },
        range: {
          txPowerValue: 0,
          roamingLevel: 0,
        },
      },
      setting: null, // ストアの一時設定参照
    }
  },
  computed: {
    BC() {
      return BC
    },

    ...mapStores(useRadioSettingsStore),

    checkBoxEntries () {
      // Object.entries をテンプレ化
      return Object.entries(this.checkBoxOptions)
    },
    gray3 () {
      return (CSS_COLORS && CSS_COLORS.GRAYSCALE3) ? CSS_COLORS.GRAYSCALE3 : '#ddd'
    },
  },
  created () {
    // ストアから設定取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォーム
    this.transSetting2Form()

    // フォーム変更を監視：設定へ反映 & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    // 設定 ← フォーム
    transForm2Setting () {
      const data = this.setting?.Network?.['Wi-Fi']
      if (!data) return

      data.ScanBand.ScanAll = this.form.checkBox.scanAll.length
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      for (let i = 0; i < this.checkBoxOptions.band2G.items.length; i++) {
        data.ScanBand['2G'][i] = this.form.checkBox.band2G.includes(i)
          ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      }
      for (let i = 0; i < this.checkBoxOptions.w52.items.length; i++) {
        data.ScanBand.W52[i] = this.form.checkBox.w52.includes(i)
          ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      }
      for (let i = 0; i < this.checkBoxOptions.w53.items.length; i++) {
        data.ScanBand.W53[i] = this.form.checkBox.w53.includes(i)
          ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      }
      for (let i = 0; i < this.checkBoxOptions.w56.items.length; i++) {
        data.ScanBand.W56[i] = this.form.checkBox.w56.includes(i)
          ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      }

      data['Wi-FiTxPowerSetting'].TxPowerValue = this.form.range.txPowerValue
      data['Wi-FiRoamingSetting'].RoamingLevel = this.form.range.roamingLevel
    },

    // 設定 → フォーム
    transSetting2Form () {
      const data = this.setting?.Network?.['Wi-Fi']
      if (!data) return

      this.form.checkBox.scanAll = (data.ScanBand.ScanAll === BC.COMMON.TOGGLE.ENABLE) ? [0] : []

      this.form.checkBox.band2G = data.ScanBand['2G'].map((ele, i) =>
        ele === BC.COMMON.TOGGLE.ENABLE ? i : null
      ).filter((i) => i !== null)
      this.form.checkBox.w52 = data.ScanBand.W52.map((ele, i) =>
        ele === BC.COMMON.TOGGLE.ENABLE ? i : null
      ).filter((i) => i !== null)
      this.form.checkBox.w53 = data.ScanBand.W53.map((ele, i) =>
        ele === BC.COMMON.TOGGLE.ENABLE ? i : null
      ).filter((i) => i !== null)
      this.form.checkBox.w56 = data.ScanBand.W56.map((ele, i) =>
        ele === BC.COMMON.TOGGLE.ENABLE ? i : null
      ).filter((i) => i !== null)

      this.form.range.txPowerValue = data['Wi-FiTxPowerSetting'].TxPowerValue
      this.form.range.roamingLevel = data['Wi-FiRoamingSetting'].RoamingLevel
    },

    isAllChannelsSelected () {
      return ['band2G', 'w52', 'w53', 'w56'].every((key) => {
        return this.form.checkBox[key].length === this.checkBoxOptions[key].items.length
      })
    },

    handleCheckBoxChange (value, type) {
      if (type === 'scanAll') {
        // 「すべて」選択 → すべての行を全選択 / 解除
        for (const key of Object.keys(this.form.checkBox)) {
          if (value.length) {
            this.form.checkBox[key] = this.checkBoxOptions[key].items.map((_e, i) => i)
          } else {
            this.form.checkBox[key] = []
          }
        }
        return
      }

      // 個別チェックが全て揃ったら「すべて」を自動チェック
      this.form.checkBox.scanAll = this.isAllChannelsSelected() ? [0] : []
    },
  },
}
</script>

<style scoped>
.checkboxGroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 40px;
}
.checkboxRow {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.rowLabel { width: 80px; }
::v-deep .el-checkbox__label {
  width: 20px;
  font-weight: normal;
}
</style>
